import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.insertEmailUserRegistration.pageTitle',
    defaultMessage: 'Verifica email',
    description: 'Title of the insert email user registration page',
  },
  pageSubtitle: {
    id: 'features.insertEmailUserRegistration.pageSubtitle',
    defaultMessage: "Inserisci l'indirizzo email da associare al servizio",
    description: 'Subtitle of the insert email user registration page',
  },
  buttonSendCodeByMail: {
    id: 'features.insertEmailUserRegistration.buttonSendCodeByMail',
    defaultMessage: 'Invia codice',
    description: 'Label of the insert email user registration button send code',
  },
  labelInsertEmailInputText: {
    id: 'features.insertEmailUserRegistration.labelInsertEmailInputText',
    defaultMessage: 'Email',
    description: 'Label of email input text',
  },
  placeholderInsertEmailInputText: {
    id: 'features.insertEmailUserRegistration.placeholderInsertEmailInputText',
    defaultMessage: 'Email (Es. nome.cognome@email.com)',
    description: 'Placeholder of email input text',
  },
  buttonVerificationCodeByMail: {
    id: 'features.insertEmailUserRegistration.buttonVerificationCodeByMail',
    defaultMessage: 'Verifica',
    description:
      'Label of the insert emial user registration button verification code',
  },
  insertEmailDisclaimer: {
    id: 'features.insertEmailUserRegistration.insertEmailDisclaimer',
    defaultMessage:
      'Tale mail verrà utilizzata per la sottoscrizione ai servizi digitali',
    description: 'Disclaimer about the insert email usage',
  },
  errorInvalidEmailFormat: {
    id: 'features.insertEmailUserRegistration.errorInvalidEmailFormat',
    defaultMessage: 'Controlla che l’indirizzo e-mail inserito sia corretto.',
    description: 'Error invalid email format ',
  },
  errorEmailNotUsableMessages: {
    id: 'features.insertEmailUserRegistration.errorEmailNotUsableMessages',
    defaultMessage:
      'L’indirizzo email risulta già associato ad un altro contratto MyAzimut. Si prega di inserire un altro indirizzo email',
    description: 'Error messages email not usable insert email ',
  },
});
